import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGoogleoptimizeComponent } from './simple-icons-googleoptimize.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGoogleoptimizeComponent ],
    exports:      [ SimpleIconsGoogleoptimizeComponent ],
    bootstrap:    []
})
export class SimpleIconsGoogleoptimizeModule {}
